import React from 'react';
import { Flex } from '../../primitives';

type Props = {
  children?: React.ReactNode;
};

const Overlay = ({ children }: Props) => (
  <Flex
    flexDirection="column"
    size="100%"
    justifyContent="center"
    alignItems="center"
    textAlign="center"
    bg="rgba(0, 0, 0, 0.4)"
    color="light"
  >
    {children}
  </Flex>
);

export default Overlay;
